/**
 * Responsive editorial images. Photos published in two sizes follow one naming
 * convention: `<name>-640.webp` (cards, phones) + `<name>-<W>.webp` (large, W > 640),
 * and the code references the LARGE file. `srcSetFor` derives the `srcset` from
 * that path; anything else (older single-size photos) gets no srcset.
 */
const RESPONSIVE = /^(.*)-(\d{3,4})\.webp$/;
const SMALL_WIDTH = 640;

export function srcSetFor(src: string): string | undefined {
  const m = RESPONSIVE.exec(src);
  if (!m) return undefined;
  const width = Number(m[2]);
  if (width <= SMALL_WIDTH) return undefined;
  return `${m[1]}-${SMALL_WIDTH}.webp ${SMALL_WIDTH}w, ${src} ${width}w`;
}

/** The 640px file of a two-size photo, or `src` itself for single-size photos. */
export function smallVariant(src: string): string {
  const m = RESPONSIVE.exec(src);
  return m && Number(m[2]) > SMALL_WIDTH ? `${m[1]}-${SMALL_WIDTH}.webp` : src;
}
